<template>
  <div class="customer-single-document">
    <show-qr-code :customer="customer" @close="loadDocument" ref="signdocument" id="customer-document-sign"
      title="Firmar Documento" :url="signature_url"></show-qr-code>
    <customer-show-document @add="documentAdded" @edit="loadDocument" ref="showdocument" :customer="customer"
      :embed="true"></customer-show-document>

    <label class="customer-single-document__title px-2">
      <strong>{{ label }}:</strong> {{ document_name }}
    </label>

    <!-- DOCUMENT EXISTS-->
    <div v-if="document" class="customer-single-document__actions">
      <template v-if="document.type == 'consent' || document.type == 'report'">
        <button v-if="document.is_signed" class="btn-wabident-round" @click="trySign(document)"
          style="background-color: var(--theme-color-attended);">
          <i class="fa fa-check" aria-hidden="true"></i>
          Firmado
        </button>
        <button v-else class="btn-wabident-round" @click="trySign(document)"><i class="fa fa-pencil"
            aria-hidden="true"></i>
          Firmar
        </button>
      </template>
      <button class="btn-wabident-round" @click="onView(document)"><i class="fas fa-search"></i>
        Ver
      </button>
    </div>
    <!-- DOCUMENT DOES NOT EXISTS-->
    <div v-else class="customer-single-document__actions">
      <button class="btn-wabident-round" @click="onUpload()"><i class="fas fa-upload"></i>
        Subir
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'value',
    'label',
    'customer',
    'deftitle',
  ],
  computed: {
    document_name() {
      if (!this.document) {
        return '';
      }

      return this.document.title;
    },
    ...mapGetters(["msgwindow", "errorwindow", "clinic"])
  },
  data() {
    return {
      signature_url: null,
      document: null,
    }
  },
  watch: {
    value(v) {
      this.loadDocument();
    }
  },
  methods: {
    onView(document) {
      window.open(`/customer/${this.customer.id}/document/${document.id}/view`);
    },
    onUpload() {
      this.$refs.showdocument.showNew(
        this.customer, null,
        null, null, 'document', this.deftitle);
    },
    loadDocument() {
      if (!this.value) {
        this.document = null;
        return;
      }

      axios.get(`/customer/${this.customer.id}/document/${this.value}`).then((response) => {
        this.document = response.data;
      }).catch((err) => {
        console.log(err);
      }).then(() => {

      });
    },
    documentAdded(v) {
      this.document = v;
      this.loadDocument();
      this.$emit('input', v.id);
    },
    resignDocument(document) {
      this.errorwindow.show(
        "Confirmación",
        "¿Deseas volver a firmar el Documento?. Esto invalidará firma anterior",
        "Firmar",
        "Cancelar",
        () => {
          this.signDocument(document, true);
        }
      );
    },
    trySign(document) {
      if (document.is_signed) {
        this.resignDocument(document);
      } else {
        this.signDocument(document);
      }
    },
    signDocument(document, resign = false) {
      if (!this.is_loading) {
        this.is_loading = true;

        let params = {};
        if (resign) {
          params.resign = true;
        }

        axios
          .get(
            `/customer/${this.customer.id}/document/${document.id}/signature`,
            { params }
          )
          .then((response) => {
            let url = response.data.url;
            if (url) {
              this.signature_url = url;
              this.$refs.signdocument.show(`*${this.clinic.name}* - *${document.title}* - Por favor, lea atentamente el Documento, rellene los datos si fuera necesario y remítanoslo firmado si acepta. Muchas gracias. \n\n`);
            } else {
              this.msgwindow.error(
                "Error firmando documento: " + (response.data.error || "")
              );
            }

          })
          .catch((error) => {
            console.log("[ERR] signDocument", error);
            this.msgwindow.error("Error firmando documento !");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
  },
  mounted() {
    this.loadDocument();
  }
}
</script>

<style lang="scss">
.customer-single-document {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;

  &__actions {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>
